import React, {useEffect} from 'react';

import {ReactComponent as BackIcon} from '../../../../../../assets/main/groups/main-top/back.svg';
import AuthWrapper from "../../../../../auth-wrapper/AuthWrapper";
import {EditLessonForm} from "./form/Edit-lesson-form";
import {MainTop} from "../../main-top/Main-top";

import {useAppDispatch} from "common/hook";
import {useParams} from "react-router-dom";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";



export const EditLesson = () => {

    const {groupId,lessonsId} = useParams();



    const dispatch = useAppDispatch();


    useEffect(() => {
        dispatch(fetchLessonsId(lessonsId));
    }, [dispatch]);


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Редактировать занятие'} tabs={false} setting={false} link={`/groups/${groupId}/lessons/${lessonsId}`}
                         icons={<BackIcon/>}/>
                <EditLessonForm/>
            </div>
        </AuthWrapper>
    );
};

